import React, { useState } from 'react';

const SignUpModale = ({ onLogin, toggleSignUpModal, toggleModal, toggleAdminLogin }) => {
    const [activeTab, setActiveTab] = useState('individual');

    const handleFormSubmit = (e) => {
        e.preventDefault();
        onLogin();
    };

    const handleLogin = () => {
        toggleSignUpModal();
        toggleModal();
    };

    return (
        <div className="flex items-center justify-center h-screen">
            <div className="relative w-full items-center flex justify-center flex-col p-8 py-12 bg-[#F6F2EF] shadow-md rounded-3xl border border-gray-200">
                <h1 className="text-2xl font-bold text-center text-[#362269] p-1 rounded-lg mb-6 w-fit">ARE YOU IN?</h1>

                <button className='absolute right-3 top-4 text-black' onClick={toggleSignUpModal}>
                    &#10006;
                </button>

                <div className="flex justify-center mb-4 w-full">
                    <button
                        onClick={() => setActiveTab('individual')}
                        className={`flex-1 text-center py-2 border-b-4 ${activeTab === 'individual' ? 'text-[#362269] border-[#C6AFFF]' : 'text-gray-500 border-transparent'}`}
                    >
                        Volunteer
                    </button>

                    <button
                        onClick={() => setActiveTab('organization')}
                        className={`flex-1 text-center py-2 border-b-4 ${activeTab === 'organization' ? 'text-[#362269] border-[#C6AFFF]' : 'text-gray-500 border-transparent'}`}
                    >
                        Organization
                    </button>
                </div>

                <form className='w-full' onSubmit={handleFormSubmit}>
                    {activeTab === 'individual' ? (
                        <div className="space-y-4">
                            <div>
                                <input
                                    type="text"
                                    placeholder="Name *"
                                    className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                                />
                            </div>

                            <div>
                                <input
                                    type="email"
                                    placeholder="Email address *"
                                    className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                                />
                            </div>

                            <div>
                                <input
                                    type="password"
                                    placeholder="Password *"
                                    className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                                />
                            </div>

                            <div className="flex flex-col justify-center items-center text-center">
                                <button
                                    type="button"
                                    className="common_btn"
                                    onClick={toggleSignUpModal}
                                    style={{ background: "#C6AFFF" }}
                                >
                                    Create Account
                                </button>
                            </div>

                            <div className='flex justify-between w-full'>
                                <span className='flex'>
                                    Already have an account? &nbsp;
                                    <button
                                        type="button"
                                        className="text-sm text-[#C6AFFF] hover:underline"
                                        onClick={handleLogin}
                                    >
                                        Log In
                                    </button>
                                </span>

                                <button
                                    type="button"
                                    className="text-sm text-[#C6AFFF] hover:underline"
                                    onClick={() => {
                                        toggleSignUpModal(); // Close the current modal
                                        toggleAdminLogin(); // Open the admin login modal
                                    }}
                                >
                                    Login as Admin
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="space-y-4">
                            <div>
                                <input
                                    type="text"
                                    placeholder="Organization Name *"
                                    className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                                />
                            </div>

                            <div>
                                <input
                                    type="email"
                                    placeholder="Organization Email *"
                                    className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                                />
                            </div>

                            <div>
                                <input
                                    type="password"
                                    placeholder="Password *"
                                    className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
                                />
                            </div>

                            <div className="flex flex-col justify-center items-center text-center">
                                <button
                                    type="button"
                                    className="common_btn"
                                    onClick={toggleSignUpModal}
                                    style={{ background: "#C6AFFF" }}
                                >
                                    Submit
                                </button>
                            </div>

                            <div className='flex justify-between w-full'>
                                <span className='flex'>
                                    Already have an account? &nbsp;
                                    <button
                                        type="button"
                                        className="text-sm text-[#C6AFFF] hover:underline"
                                        onClick={handleLogin}
                                    >
                                        Log in
                                    </button>
                                </span>

                                <button
                                    type="button"
                                    className="text-sm text-[#C6AFFF] hover:underline"
                                    onClick={() => {
                                        toggleSignUpModal(); // Close the current modal
                                        toggleAdminLogin(); // Open the admin login modal
                                    }}
                                >
                                    Login as Admin
                                </button>
                            </div>
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};

export default SignUpModale;
